// Authentication API endpoints - Updated to match mobile app structure
export const AUTH_ENDPOINTS = {
  // User management - Mobile app format
  USERS: "/users/deleteGetPatchUser/",
  USER_DETAIL: "/users/deleteGetPatchUser/{id}/",
  PROFILE: "/users/getUserInfo/",
  CREATE_USER: "/users/createUser/",
  INVITATIONS: (buildingId: number) => `/users/invitations/${buildingId}/`,
  INVITATION_ACCEPT: "/users/invitations/accept",

  // Authentication - Mobile app format
  LOGIN: "/users/token-auth/",
  LOGOUT: "/users/logout/",
  TOKEN_REFRESH: "/users/token-refresh/",

  // Password management
  PASSWORD_CHANGE: "/auth/password/change/",
  PASSWORD_RESET: "/auth/password/reset/",
  PASSWORD_RESET_CONFIRM: "/auth/password/reset/confirm/",

  // Email verification
  EMAIL_VERIFY: "/auth/email/verify/",

  // MFA
  MFA_SETUP: "/auth/mfa/setup/",
  MFA_VERIFY: "/auth/mfa/verify/",

  // Health check
  HEALTH: "/auth/health/",
} as const;
